// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import formatBytes from "bytes";

interface IProps {
  bytes: bigint;
}

export function BytesDisplay({ bytes }: IProps): JSX.Element {
  // Our IPC native addon using unsigned long long for storing bytes number so
  // we are okay to cast here bigint to Number, as it won't have any critical
  // precision lost. Max value for unsigned long long 18446744073709551615.
  const formattedBytes: string = formatBytes(Number(bytes), {
    unitSeparator: " ",
  });
  return <span>{formattedBytes}</span>;
}
